const playlistCache = new Map(); // key = JSON.stringify(answers)
export default playlistCache;
